{
  "bodyInputLabel": "Corps",
  "bodyInputPlaceholder": "Décrivez votre problème :",
  "callUs": "Appelez-nous",
  "cancel": "Annuler",
  "chooseYourProduct": "Choisissez votre produit",
  "contactUs": "Contactez-nous",
  "continue": "Continuer",
  "createSupportTicketDescription": "Créez un ticket d'assistance dans notre système pour obtenir une assistance directe de l'un de nos collaborateurs.",
  "createSupportTicketHelpContentWithPhoneNumber": "Les tickets d'assistance sont régulièrement examinés et traités par notre équipe. Si vous préférez parler à quelqu'un, vous pouvez nous appeler au {{phoneNumber}}.",
  "createSupportTicketTitle": "Créer un ticket d'assistance",
  "emailUs": "Envoyez-nous un e-mail",
  "exitAppPromptMessage": "Vous êtes sur le point de naviguer vers app.farmhq.com pour accéder à la documentation d'assistance.",
  "exitAppPromptTitle": "Continuer vers FarmHQ Web ?",
  "farmHqIsHereToHelp": "FarmHQ est là pour vous aider ! Contactez-nous pour tout problème que vous pourriez rencontrer et nous vous répondrons dans les plus brefs délais.",
  "getHelpWithFarmHq": "Obtenez de l'aide avec FarmHQ",
  "sendUsAMessage": "Envoyez-nous un message",
  "shareFeedback": "Partager vos commentaires",
  "shareFeedbackDescription": "Faites-nous savoir comment notre produit fonctionne pour vous et comment nous pouvons l’améliorer encore davantage.",
  "subjectInputLabel": "Sujet",
  "subjectInputPlaceholder": "J'ai besoin d'aide avec...",
  "support": "Soutien",
  "supportCenter": "Centre d'assistance",
  "supportDocumentationLink": "Consulter la documentation d'assistance",
  "title": "Centre d'assistance",
  "topic_one": "Sujet",
  "topic_other": "Thèmes",
  "viewInstructionManual": "Voir le manuel d'instructions",
  "viewSupportDocsDescription": "Lisez la documentation sur l'installation, le dépannage, l'utilisation de l'application et d'autres problèmes sur app.farmhq.com.",
  "weHaveReceivedYourMessage": "Nous avons reçu votre message !"
}
